
import Footer from '../sections/Footer';
import TermCondition from '../sections/T&C';
import Header from '../sections/Header';
import Contact from '../sections/Contact';
const TermAndCondition = () => {
  
  return(
          <>
          <Header/>
          <TermCondition/>
          <Footer/>
          </>
  
      )
};

export default TermAndCondition;